export enum TreatmentPlanType {
  LITE = 'LITE',
  MODERATE = 'MODERATE',
  ADVANCED = 'ADVANCED',
  NONE = 'NONE',
  OTHER = 'OTHER',
}

export enum TreatmentPlanTask {
  TO_SUBMIT = 'TO_SUBMIT',
  DIAGNOSIS_TO_DO = 'DIAGNOSIS_TO_DO',
  DIAGNOSIS_SUBMITTED = 'DIAGNOSIS_SUBMITTED',
  LETTER_TO_DO = 'LETTER_TO_DO',
  LETTER_SUBMITTED = 'LETTER_SUBMITTED',
  LETTER_SENT = 'LETTER_SENT',
  IN_TREATMENT = 'IN_TREATMENT',
  TREATMENT_PRE_FINISH = 'TREATMENT_PRE_FINISH',
  TREATMENT_POST_FINISH = 'TREATMENT_POST_FINISH',
  COMPLETED = 'COMPLETED',
}

export enum TaskBlockReason {
  REFFERED = 'REFFERED',
  REFUSED = 'REFUSED',
  RECALL = 'RECALL',
  RETAINER = 'RETAINER',
  PENDING = 'PENDING',
  DENTAL_TX_REQUIRED = 'DENTAL_TX_REQUIRED',
  OTHER = 'OTHER',
}

export const taskBlockReasonsText = {
  REFFERED: 'Referred to Ortho',
  REFUSED: 'Refused',
  RECALL: 'Recall',
  RETAINER: 'Retainer',
  PENDING: 'Pending',
  DENTAL_TX_REQUIRED: 'Dental Tx required',
} as const;

export const TreatmentPlanText = {
  LITE: 'Lite',
  MODERATE: 'Moderate',
  ADVANCED: 'Advanced',
  NONE: 'Not Selected',
  OTHER: 'Other',
};

export enum AlignerTreatmentPlanUpperOrLowerType {
  UPPER = 'UPPER',
  LOWER = 'LOWER',
  UPPER_AND_LOWER = 'UPPER_AND_LOWER',
  NONE = 'NONE',
}

export const AlignerTreatmentPlanText = {
  UPPER: 'Upper',
  LOWER: 'Lower',
  UPPER_AND_LOWER: 'Upper and Lower',
  NONE: 'None',
};
